import React from 'react';
import { WorkspaceModulesManager } from './components/WorkspaceModulesManager';

/**
 * Workspace Modules Management View
 * Allows users to enable/disable modules in their workspace
 */
export function WorkspaceModulesView() {
  return (
    <div className="p-8 bg-gradient-to-br from-slate-50 to-white min-h-screen">
      <div className="max-w-6xl mx-auto">
        <WorkspaceModulesManager />
      </div>
    </div>
  );
}
